import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useMoves() {
    const api = useApi();
    const state = useAppState();
    function getCompletedMoves(onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CompletedMoves", (result) => {
            state.completedMoves = result;
            if (onSuccess) {
                onSuccess(result);
            }
        }, /* useCache: */ true);
    }
    function getPendingMoves(onSuccess = null, groupFiltered = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Moves", (result) => {
            state.pendingMoves = result;
            if (state.pendingMoves == null) {
                state.pendingMoves = [];
            }
            state.pendingMoves = state.pendingMoves.filter((move) => move.move.enabled !== false);
            if (groupFiltered) {
                var pendingMovesGrouped = state.pendingMoves.reduce((groups, move) => {
                    if (!groups[move.move.appScreen]) {
                        groups[move.move.appScreen] = [];
                    }
                    groups[move.move.appScreen].push(move);
                    return groups;
                }, {});
                state.pendingMoves = [];
                for (const key in pendingMovesGrouped) {
                    // eslint-disable-next-line no-restricted-syntax -- initial population of empty array
                    state.pendingMoves.push(pendingMovesGrouped[key][0]);
                }
            }
            if (onSuccess) {
                onSuccess(state.pendingMoves);
            }
        }, /* useCache: */ true);
    }
    function getCustomerMove(moveId, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Moves/" + moveId, (result) => {
            state.customerMove = result;
            if (onSuccess) {
                onSuccess(result);
            }
        }, /* useCache: */ true);
    }
    function clearMoves() {
        const config = getApiConfig();
        localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/Moves');
        localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/CompletedMoves');
    }
    function markCustomerMoveAsSeen(moveId, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Moves/" + moveId + "/MarkAsSeenRequests", null)
            .then((response) => {
            if (onSuccess) {
                onSuccess(response);
            }
        })
            .catch((result) => {
            if (result.response.status == 401) {
                api.refreshLogin(() => {
                    markCustomerMoveAsSeen(moveId, onSuccess);
                });
            }
        });
    }
    function markCustomerMoveAsActioned(moveId, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Moves/" + moveId + "/MarkAsActionedRequests", null)
            .then((response) => {
            clearMoves();
            if (onSuccess) {
                onSuccess(response);
            }
        })
            .catch((result) => {
            if (result.response.status == 401) {
                api.refreshLogin(() => {
                    markCustomerMoveAsActioned(moveId, onSuccess);
                });
            }
        });
    }
    return {
        getCompletedMoves,
        getPendingMoves,
        getCustomerMove,
        clearMoves,
        markCustomerMoveAsSeen,
        markCustomerMoveAsActioned,
    };
}
